import React, { useEffect, useState } from 'react';

import { usePage } from '@/src/app/hooks';
import { Constants } from '@/src/utils';

/**
 * A small dismissable bar shown when Spanish (ES) is selected on a grade that
 * has no Spanish translations. The banner re-appears whenever the user selects
 * ES again (or refreshes) on a non-allowed grade, since translations fall back
 * to English in that case.
 */
const ESLanguageBanner: React.FC = () => {
    const { pageLanguage, pageGrade } = usePage();
    const [dismissed, setDismissed] = useState(false);

    const unavailable = pageLanguage === 'ES' && !Constants.ALLOWED_ES_GRADES.includes(pageGrade);

    // Re-show the banner whenever the grade or language changes, e.g. when the
    // user selects ES on a grade without translations.
    useEffect(() => {
        setDismissed(false);
    }, [pageLanguage, pageGrade]);

    if (!unavailable || dismissed) return null;

    return (
        <div
            role="alert"
            className="pd-GK-primary background"
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                padding: '8px 16px',
                color: '#2C2C2C',
                fontSize: '14px',
                textAlign: 'center',
            }}
        >
            <span>
                Spanish is not available for Grade {pageGrade}. Content is shown in English.
            </span>
            <button
                aria-label="Dismiss"
                onClick={() => setDismissed(true)}
                style={{
                    background: 'none',
                    border: 'none',
                    color: 'inherit',
                    fontSize: '20px',
                    lineHeight: 1,
                    cursor: 'pointer',
                    padding: 0,
                }}
            >
                &times;
            </button>
        </div>
    );
};

export default ESLanguageBanner;
